import { Box, lighten } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledBox = styled(Box)(({ theme }) => ({
  '& .ESPTitleGrid': {
    justifyContent: 'center',
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.down('xl')]: {
      alignItems: 'center',
    },
  },
  '& .ESPTitle': {
    color: theme.palette.secondary.dark,
    marginBottom: theme.spacing(3),
    [theme.breakpoints.down('md')]: {
      marginBottom: theme.spacing(4),
    },
    [theme.breakpoints.down('lg')]: {
      marginBottom: theme.spacing(2),
    },
  },
  '& .ESPSeeMoreBtn': {
    padding: theme.spacing(0.75, 2),
    marginTop: theme.spacing(2),
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.common.fogWhite,
    [theme.breakpoints.up('md')]: {
      marginTop: theme.spacing(3),
    },
    [theme.breakpoints.up('xl')]: {
      marginTop: theme.spacing(0),
    },
    [theme.breakpoints.down('md')]: {
      width: '100%',
    },
    '&:hover': {
      backgroundColor: lighten(theme.palette.secondary.main, 0.2),
    },
  },
  '& .ESPCard': {
    borderRadius: theme.spacing(2),
    border: ` 1px solid ${theme.palette.grey[100]}`,
    overflow: 'hidden',
  },
  '& .ESPCardText': {
    padding: theme.spacing(2),
    color: theme.palette.grey[600],
  },
  '& .ESPCardTitle': {
    fontWeight: 300,
    color: theme.palette.secondary.main,
  },
  '& .ESPCardDesc': {
    fontSize: theme.spacing(1.625),
    color: theme.palette.secondary.main,
  },
  [theme.breakpoints.up('xl')]: {
    '& .showTABLET': {
      display: 'none',
    },
  },
  [theme.breakpoints.down('xl')]: {
    '& .showDESKTOP': {
      display: 'none',
    },
  },
  [theme.breakpoints.down('md')]: {
    '& .hiddenMOBILE': {
      display: 'none',
    },
  },
}));

export default StyledBox;
